const theme = {
  colors: {
    primary: "var(--primary-color)",
    primaryLight: "var(--primary-light)",
    primaryDark: "var(--primary-dark)",
    secondary: "var(--secondary-color)",
    accent: "var(--accent-color)",
    background: "var(--background-color)",
    backgroundSecondary: "var(--background-secondary)",
    backgroundTertiary: "var(--background-tertiary)",
    surface: "var(--surface-color)",
    text: "var(--text-color)",
    textSecondary: "var(--text-secondary)",
    textTertiary: "var(--text-tertiary)",
    error: "var(--error-color)",
    success: "var(--success-color)",
    border: "var(--border-color)",
    borderLight: "var(--border-color-light)",

    // Luxury palette
    gold: "#d4af37",
    goldLight: "#f5e7a3",
    goldDark: "#9e7c2b",
    goldPale: "#fbf5b7",
    goldRich: "#bf953f",
    goldAntique: "#b38728",
    goldBurnished: "#aa771c",
    black: "#000000",
    blackRich: "#0c0c0c",
    blackSmoke: "#171717",
    blackCharcoal: "#1a1a1a",
  },

  fonts: {
    heading: "'Playfair Display', serif",
    subheading: "'Cormorant Garamond', serif",
    body: "'Montserrat', sans-serif",
  },

  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    black: 900,
  },

  borderRadius: "var(--border-radius)",
  boxShadow: "var(--box-shadow)",
  luxuryShadow: "var(--luxury-shadow)",
  goldShadow: "var(--gold-shadow)",
  transition: "var(--transition)",

  breakpoints: {
    xs: "480px",
    sm: "576px",
    md: "768px",
    lg: "992px",
    xl: "1200px",
  },

  spacing: {
    xxs: "0.125rem",
    xs: "0.25rem",
    sm: "0.5rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem",
    xxl: "3rem",
    xxxl: "5rem",
  },

  fontSize: {
    xxs: "0.625rem",
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.25rem",
    xl: "1.5rem",
    xxl: "2rem",
    xxxl: "3rem",
    display: "4rem",
  },

  letterSpacing: {
    tight: "-0.05em",
    normal: "0",
    wide: "0.05em",
    wider: "0.1em",
    widest: "0.2em",
  },

  gradients: {
    gold: "var(--gold-gradient)",
    goldToBlack:
      "linear-gradient(to bottom, var(--primary-color), var(--background-color))",
    darkGold:
      "linear-gradient(135deg, var(--primary-dark), var(--primary-color))",
    goldShimmer:
      "linear-gradient(90deg, #bf953f, #fcf6ba, #b38728, #fbf5b7, #aa771c)",
    goldLight: "linear-gradient(90deg, #f5e7a3, #ffffff, #f5e7a3)",
    blackGold: "linear-gradient(to right, #000000, #333333, #000000)",
  },

  effects: {
    shimmer: "var(--gold-shine)",
    glow: "0 0 10px rgba(212, 175, 55, 0.3), 0 0 20px rgba(212, 175, 55, 0.2)",
    goldEdge: "0 0 0 1px rgba(212, 175, 55, 0.5)",
    textShadow: "0 2px 4px rgba(0, 0, 0, 0.5)",
    goldTextShadow: "0 2px 4px rgba(212, 175, 55, 0.3)",
  },

  animations: {
    fadeIn: "fadeIn 0.5s ease-in-out",
    slideUp: "slideUp 0.5s ease-out",
    pulse: "pulse 2s infinite",
    shimmer: "shimmer 6s infinite linear",
    glow: "glow 4s ease-in-out infinite",
  },
};

export default theme;
